import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bank_transfer_text_container" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_FormField = _resolveComponent("FormField")!
  const _component_SumupCheckoutWidgetModal = _resolveComponent("SumupCheckoutWidgetModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SelectButton, {
      modelValue: _ctx.paymentMethod,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentMethod) = $event)),
      options: _ctx.methodOptions,
      optionLabel: _ctx.getRegisterPaymentMethodLabel,
      invalid: (_ctx.tryToProcess && _ctx.paymentMethod == null)
    }, null, 8, ["modelValue", "options", "optionLabel", "invalid"]),
    (_ctx.paymentMethod === _ctx.methodBankTransfer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "bankTransferText", {}, undefined, true)
          ]),
          _createVNode(_component_FormField, {
            label: _ctx.$t('global_components.payment_processor.view.payment_receipt'),
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FileUpload, {
                multiple: false,
                maxFileSize: 104857600,
                fileLimit: 1,
                onSelect: _ctx.paymentReceiptSelect,
                onRemove: _ctx.paymentReceiptRemove,
                showCancelButton: false,
                showUploadButton: false,
                customUpload: true,
                chooseLabel: _ctx.$t('global_components.payment_processor.view.choose_button'),
                pt: {
                              root: {
                                class: (_ctx.fileUploadError || _ctx.tryToProcess > 2 && _ctx.isNull(_ctx.paymentReceipt)) ? 'p-invalid' : ''
                              },
                               fileThumbnail: {
                                 style: 'display: none'
                              },
                              pcProgressBar: {
                               root: {
                                 style: 'display: none'
                               }
                              },
                              pcFileBadge: {
                                root: {
                                  style:'display: none'
                                }
                              }
                            }
                
              }, {
                empty: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('global_components.payment_processor.view.upload_text')), 1)
                ]),
                _: 1
              }, 8, ["onSelect", "onRemove", "chooseLabel", "pt"])
            ]),
            _: 1
          }, 8, ["label"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.paymentMethod === _ctx.methodSumup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('global_components.payment_processor.view.payment_sumup_infos')), 1),
          _createVNode(_component_SumupCheckoutWidgetModal, {
            ref: "sumupCheckoutWidgetModal",
            checkoutId: _ctx.payment?.sumupCheckoutId,
            onStatusChange: _ctx.paymentStatusChange
          }, null, 8, ["checkoutId", "onStatusChange"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}